/** Shared UTC date helpers for timeline components (EmployeeTimeline, PayRangeVersionTimeline). */

export const MS_DAY = 24 * 60 * 60 * 1000;

export const MONTH_ABBR = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export function toTime(value) {
  if (value == null || value === "") return null;
  const d = value instanceof Date ? value : new Date(value);
  const t = d.getTime();
  return Number.isNaN(t) ? null : t;
}

export function toIso(value) {
  if (value == null || value === "") return null;
  if (value instanceof Date) return value.toISOString().slice(0, 10);
  return String(value).slice(0, 10);
}

export function startOfYear(ms) {
  return Date.UTC(new Date(ms).getUTCFullYear(), 0, 1);
}

export function startOfMonth(ms) {
  const d = new Date(ms);
  return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1);
}

export function startOfQuarter(ms) {
  const d = new Date(ms);
  const qMonth = Math.floor(d.getUTCMonth() / 3) * 3;
  return Date.UTC(d.getUTCFullYear(), qMonth, 1);
}

export function alignStart(ms, scale) {
  if (scale === "months") return startOfMonth(ms);
  if (scale === "quarters") return startOfQuarter(ms);
  return startOfYear(ms);
}

export function addUnit(ms, scale) {
  const d = new Date(ms);
  if (scale === "years") {
    return Date.UTC(d.getUTCFullYear() + 1, d.getUTCMonth(), d.getUTCDate());
  }
  if (scale === "months") {
    return Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + 1, 1);
  }
  return Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + 3, 1);
}

export function subUnit(ms, scale) {
  const d = new Date(ms);
  if (scale === "years") {
    return Date.UTC(d.getUTCFullYear() - 1, d.getUTCMonth(), d.getUTCDate());
  }
  if (scale === "months") {
    return Date.UTC(d.getUTCFullYear(), d.getUTCMonth() - 1, 1);
  }
  return Date.UTC(d.getUTCFullYear(), d.getUTCMonth() - 3, 1);
}

export function stepUnits(ms, scale, n) {
  let t = ms;
  const stepFn = n >= 0 ? addUnit : subUnit;
  for (let i = 0; i < Math.abs(n); i += 1) t = stepFn(t, scale);
  return t;
}

export function diffDays(startMs, endMs) {
  if (startMs == null || endMs == null) return 0;
  return Math.max(0, Math.round((endMs - startMs) / MS_DAY));
}

export function formatAxisYear(ms) {
  return String(new Date(ms).getUTCFullYear());
}

export function formatAxisQuarter(ms) {
  const d = new Date(ms);
  return `Q${Math.floor(d.getUTCMonth() / 3) + 1}`;
}

export function formatAxisMonth(ms) {
  return MONTH_ABBR[new Date(ms).getUTCMonth()];
}
